import React, {useState, useEffect} from 'react';
import styled from "styled-components";
import SwiperCore, {Navigation, Pagination,} from 'swiper';
import {Swiper, SwiperSlide} from "swiper/react";
import Skeleton from 'react-loading-skeleton';
import SwiperFullscreen from './fullscreen';
import {array_chunk, array_unique} from "@helpers/arrays";
import RadiusGenerate from "@helpers/radius.generate";
import {useWindowSize} from "@helpers/windows.size";
import {isEmpty} from "@helpers/helpers";
import {getImagePath, getThumbnailPath, getAparatVideoPath} from "@models/property";
import {handleLockBrowserScroll} from "@helpers/helpers";

// install Swiper components
SwiperCore.use([Navigation, Pagination]);

var fullscreenOpened = false;

function SwiperSlider({property, skeleton_count}) {
    const windowSize = useWindowSize();
    const [firstShow, setFirstShow] = useState(false);
    const [fullscreen, setFullscreen] = useState({show: false, slideTo: 0});
    const [media, setMedia] = useState([...Array(Number(skeleton_count))]);
    const [video, setVideo] = useState(null);

    useEffect(() => {
        const bodyClasses = document.body.classList;

        if (fullscreen.show) {
            fullscreenOpened = true;
            bodyClasses.add('swiper-open');

            handleLockBrowserScroll(true);

            window.history.pushState(null, "", window.location.href);

            window.onpopstate = () => {
                window.history.pushState('back', null, null);

                if (fullscreen.show) {
                    setFullscreen({show: false, slideTo: 0})
                }
            };
        } else {
            const checkBodyClasses = (!bodyClasses.contains('selection-open') &&
                !bodyClasses.contains('menu-open') &&
                !bodyClasses.contains('filter-open') &&
                !bodyClasses.contains('modal-open'));

            if (checkBodyClasses) {
                handleLockBrowserScroll(false);
            }

            if (!isEmpty(window.onpopstate) && fullscreenOpened) {
                fullscreenOpened = false;
                window.onpopstate = undefined;
                window.history.back();
            }

            bodyClasses.remove('swiper-open');
        }
    }, [fullscreen]);

    useEffect(() => {
        if (!isEmpty(property)) {
            if (!property.archived && !isEmpty(property.media) && property.media.length) {
                let mediaItems = [...property.media];

                for (const key in mediaItems) {
                    const media = mediaItems[key];

                    if (media.type === 'video') {
                        setVideo(media);
                        delete mediaItems[key];
                    }

                    if (media.is_cover) {
                        const temp = mediaItems[0];
                        mediaItems[0] = media;
                        mediaItems[key] = temp;
                    }
                }

                mediaItems = array_unique(mediaItems);
                setMedia(mediaItems);
            } else {
                setMedia([]);
            }
        } else {
            setMedia([...Array(Number(skeleton_count))])
        }
    }, [property]);

    const chunked_swipers = array_chunk(media, 5);

    let slidesPerView = 1;
    if ((media.length > 1 || (!isEmpty(video) && media.length > 0)) && windowSize > 767) {
        slidesPerView = 2;
    }

    const handleItems = (chunk, main_key) => {
        if (chunk.length && chunk.length < 3) {
            return (
                <React.Fragment key={main_key}>
                    {
                        chunk.map((item, key) =>
                            <SwiperSlide key={key}>
                                {
                                    (!isEmpty(property) && !isEmpty(item)) ?
                                        <ReturnMedia media={item} mediaCount={media.length} onClick={() => handleClick((main_key * 5) + key)} property={property}/>
                                        :
                                        <Skeleton className="swiper-skeleton" height={'100%'} width={'100%'}/>
                                }
                            </SwiperSlide>
                        )
                    }
                </React.Fragment>
            )
        } else if (chunk.length && chunk.length > 2) {
            const classes = {1: 'full', 2: 'half', 3: 'third', 4: 'quarter'};
            const slideClass = classes[chunk.length - 1];

            return (
                <React.Fragment key={main_key}>
                    <SwiperSlide>
                        {
                            (!isEmpty(property) && !isEmpty(chunk[0])) ?
                                <ReturnMedia media={chunk[0]} mediaCount={media.length} onClick={() => handleClick((main_key * 5))} property={property} size={{w: 480, h: 400}}/>
                                :
                                <Skeleton className="swiper-skeleton" height={'100%'} width={'100%'}/>
                        }
                    </SwiperSlide>

                    <SwiperSlide className={slideClass}>
                        {
                            chunk.map((item, key) => {
                                {
                                    if (key > 0) {
                                        return (
                                            <Item key={key} status={slideClass}>
                                                {
                                                    (!isEmpty(property) && !isEmpty(item)) ?
                                                        <ReturnMedia media={item} mediaCount={media.length} onClick={() => handleClick((main_key * 5) + key)} property={property}/>
                                                        :
                                                        <Skeleton className="swiper-skeleton" height={'100%'} width={'100%'}/>
                                                }
                                            </Item>
                                        )
                                    }
                                }
                            })
                        }
                    </SwiperSlide>
                </React.Fragment>
            )
        }
    };

    const handleClick = (slidTo) => {
        setFullscreen({show: true, slideTo: slidTo});

        if (!firstShow) {
            setFirstShow(true);
        }
    };

    const navigation = {
        nextEl: '.swiper-next',
        prevEl: '.swiper-prev',
    };

    if (media.length || !isEmpty(video)) {
        return (
            <Container className={"position-relative " + (!isEmpty(video) ? 'has-video' : '')}>
                <div className="swiper-button-next swiper-next"/>
                <div className="swiper-button-prev swiper-prev"/>

                <Slider
                    spaceBetween={8}
                    slidesPerView={slidesPerView}
                    navigation={navigation}
                    pagination={{type: 'bullets', dynamicBullets: true}}>

                    {
                        !isEmpty(video) ?
                            <SwiperSlide>
                                <div className="h_iframe-aparat_embed_frame">
                                    <span style={{display: 'block', paddingTop: '57%'}}/>
                                    <iframe src={getAparatVideoPath(video.code)} allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"/>
                                </div>
                            </SwiperSlide>
                            : ''
                    }

                    {
                        (windowSize > 767) ?
                            chunked_swipers.map((chunk, key) => handleItems(chunk, key))
                            :
                            media.map((item, key) =>
                                <SwiperSlide key={key}>
                                    {
                                        (!isEmpty(property) && !isEmpty(item)) ?
                                            <ReturnMedia media={item} mediaCount={media.length} onClick={() => handleClick(key)} property={property} size={{w: 480, h: 255}}/>
                                            :
                                            (
                                                (key === 0) ?
                                                    <Skeleton className="swiper-skeleton" height={'100%'} width={'100%'}/>
                                                    : ''
                                            )
                                    }
                                </SwiperSlide>
                            )
                    }
                </Slider>

                {
                    (!isEmpty(property) && media.length && firstShow) ?
                        <SwiperFullscreen
                            media={media}
                            property_id={property.id}
                            property_boosted_at={property.boosted_at}
                            property_image_title={property.title + ' ' + property.street}
                            slide_to={fullscreen.slideTo}
                            show={fullscreen.show}
                            setShow={setFullscreen}/>
                        : ''
                }

            </Container>
        )
    } else if (windowSize < 768 && !isEmpty(property) && !property.archived) {
        return (
            <Container className="no-image">
                <img src={getThumbnailPath()} alt={(!isEmpty(property) ? property.title : '')} className="img-cover"/>
            </Container>
        )
    } else {
        return null;
    }
}

export default SwiperSlider;

function ReturnMedia({media, mediaCount, onClick, property, size = {w: 480, h: 255}}) {

    return (
        <img src={(mediaCount > 2) ? getThumbnailPath(property, size, media) : getImagePath(property.id, media, property.boosted_at)} alt={(!isEmpty(property) ? property.title : '')} className="img-cover" onClick={onClick}/>
    )
}

// styles

export const Container = styled.div`

     .h_iframe-aparat_embed_frame{position:relative; height: 100%}
     .h_iframe-aparat_embed_frame .ratio{display:block;width:100%;height:auto;}
     .h_iframe-aparat_embed_frame iframe{position:absolute;top:0;left:0;width:100%;height:100%;}

    &.no-image {
        height: 68vw;
        width: 100%;
    }

    .swiper-prev {
        right: -27px;
        left: auto;
        
        &:after {
            content: 'next';
        }
    }
    
    .swiper-next {
        left: -27px;
        right: auto;
        
         &:after {
            content: 'prev';
        }
    }
    
    .swiper-prev, .swiper-next {
        width: auto;
        height: auto; 
        top: 55%;
        
        &:after {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #222;
            font-weight: 500;
            font-size: 24px;
            width: 54px;
            height: 54px;
            box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.12);
            background-color: #ffffff;
            ${RadiusGenerate('50px')}
        }
    }
    
    .swiper-prev.swiper-button-disabled, .swiper-next.swiper-button-disabled {
        opacity: 0;
    }
    
    .swiper-pagination{
        bottom: 24px;
    }
    
    .swiper-pagination-bullet {
        width: 6px;
        height: 6px;
        background-color: #ffffff;
        opacity: 1;
    }
    
    .swiper-pagination-bullet-active {
        width: 8px;
        height: 8px;
        background-color: #ffffff;;
    }
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        .swiper-prev,.swiper-next {
            display: none;
        }
                
        &.has-video {
            .swiper-prev,.swiper-next {
                display: block;
                &:after {
                    background-color: transparent;
                    color: #ffffff;
                    box-shadow: none;
                }
            }
            
            .swiper-next {
                left: 0;
            }
            
            .swiper-prev {
                right: 0;
            }
        }
    }
`;

const Item = styled(SwiperSlide)`
    width: ${props => props.status === 'half' ? '100%' : '50%'} !important;
    height: ${props => props.status === 'half' ? '100%' : '50%'} !important;
    overflow: hidden;
	flex-shrink: 1 !important;
    
     &:last-child {
        width: ${props => props.status === 'quarter' ? '50%' : '100%'} !important;
     }
`;

const Slider = styled(Swiper)`
    height: 400px;
    max-height: 400px;
    ${RadiusGenerate('16px')}
    
    img {
        box-sizing: border-box;
        background-color: ${props => props.theme.gray100};
    }
    
    .swiper-slide {
        cursor: pointer;
        background-color: ${props => props.theme.gray100};
        
        span {
            width: 100%;
            height: 100%;
            line-height: 111;
        }
    }
    
    .half {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: flex-start;
        
        ${Item}:first-child {
            img, .swiper-skeleton{
                border-bottom: 4px solid #fff;
            }
        }
        
        ${Item}:last-child {
            img, .swiper-skeleton{
                border-top: 4px solid #fff;
            }
        }
    }
    
    .third,.quarter {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
    }
    
    .third {
        ${Item}:first-child {
            img, .swiper-skeleton{
                border-left: 8px solid #fff;
            }
        }

        ${Item}:last-child {
            img, .swiper-skeleton{
                border-top: 8px solid #fff;
            }
        }
    }
    
    .quarter {
        ${Item}:first-child {
            img, .swiper-skeleton{
                border-left: 4px solid #fff;
                border-bottom: 4px solid #fff;
            }
        }

        ${Item}:nth-child(2) {
            img, .swiper-skeleton{
                border-right: 4px solid #fff;
                border-bottom: 4px solid #fff;
            }
        }

        ${Item}:nth-child(3) {
            img, .swiper-skeleton{
                border-left: 4px solid #fff;
                border-top: 4px solid #fff;
            }
        }
        
        ${Item}:last-child {
            img, .swiper-skeleton{
                border-top: 4px solid #fff;
                border-right: 4px solid #fff;
            }
        }
    }
    
    .swiper-pagination{
        bottom: 24px;
    }
    .swiper-pagination-bullet {
        width: 6px;
        height: 6px;
        background-color: #ffffff;
        opacity: 1;
    }
    .swiper-pagination-bullet-active {
        width: 8px;
        height: 8px;
        background-color: #ffffff;;
    }
    
    @media (min-width: ${props => props.theme.screenXsMax}) {
        .swiper-pagination {
            display: none;
        }
    }
    @media (max-width: ${props => props.theme.screenXsMax}) {
        ${RadiusGenerate('0')};
        height: 68vw;
        max-height: 68vw;
    }
   
`;